import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper"; // im using "react-p5-wrapper": "^3.0.2", do not remove this comment

function grid(p) {
  const GRID_COLOR = [200, 200, 200, 80]; 
  p.push();
  p.stroke(...GRID_COLOR);
  p.strokeWeight(1);
  let step = 40; 
  let gridSize = 2000;
  for (let x = -gridSize; x <= gridSize; x += step) {
    p.line(x, -gridSize, x, gridSize);
  }
  for (let y = -gridSize; y <= gridSize; y += step) {
    p.line(-gridSize, y, gridSize, y);
  }
  p.pop();
}

export const Rewindtime = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {
  const sketch = (p) => {
    const BLACK = [51, 51, 51];
    const BEIGE = [255, 254, 246];

    let firstText = "If only the hands moved back,";
    let secondText = "to trade our past for more now.";
    let latoFont = "Lato";
    let feelWidths = [];
    let doWidths = [];
    let spaceKerning = 4.75;

    const letter_extra_space = {
      a: 1.05, b: 1, c: 1, d: 1, e: 1.5, f: 0, g: 1, h: 1, i: 1, j: 1,
      k: 1, l: 0.1, m: 1, n: 1, o: 1, p: 1, q: 1, r: -0.2, s: 2, t: 0,
      u: 1, v: 0, w: 0, x: 1, y: 1, z: 1,
    };

    function loadGoogleFont() {
      const link = document.createElement("link");
      link.href = "https://fonts.googleapis.com/css2?family=Lato&display=swap";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }

    p.setup = () => {
      loadGoogleFont();
      p.createCanvas(wt, ht);
      p.rectMode(p.CENTER);
      p.ellipseMode(p.CENTER);
      p.textAlign(p.LEFT, p.CENTER);
      p.textSize(fs);
      p.textFont(latoFont);

      for (let i = 0; i < firstText.length; i++) {
        let extra = firstText[i] === " " ? spaceKerning : letter_extra_space[firstText[i]] || 0;
        feelWidths[i] = p.textWidth(firstText[i]) + extra;
      }
      for (let i = 0; i < secondText.length; i++) {
        let extra = secondText[i] === " " ? spaceKerning : letter_extra_space[secondText[i]] || 0;
        doWidths[i] = p.textWidth(secondText[i]) + extra;
      }
    };

    const statictext = () => {
      p.push();
      p.textSize(fs);
      p.textFont(latoFont);
      p.textAlign(p.LEFT, p.CENTER);
      p.fill(BLACK);

      let cx = p.width / 2;
      let firstY = p.height - 120;
      let secondY = firstY + 24;

      let firstWidth = feelWidths.reduce((a, b) => a + b, 0);
      let secondWidth = doWidths.reduce((a, b) => a + b, 0);

      let x = cx - firstWidth / 2;
      for (let i = 0; i < firstText.length; i++) {
        p.text(firstText[i], x, firstY);
        x += feelWidths[i];
      }

      x = cx - secondWidth / 2;
      for (let i = 0; i < secondText.length; i++) {
        p.text(secondText[i], x, secondY);
        x += doWidths[i];
      }
      p.pop();
    };

    const maincontent = () => {
      p.push();
      p.translate(p.width / 2, p.height / 2.25);

      // --- Updated Clock Design ---
      let clockSize = 220; // Larger circle
      let handLength = 80; // Shorter hand
      
      // Draw Clock Face (Outer Circle)
      p.noFill();
      p.stroke(BLACK);
      p.strokeWeight(1.5); // Slightly thinner for a more delicate look
      p.ellipse(0, 0, clockSize);

      // Draw Center Pin
      p.fill(BLACK);
      p.noStroke();
      p.ellipse(0, 0, 5);

      // Reverse Hand Logic - Slower Speed
      // Reduced from 0.05 to 0.015 for a slower, more weighted crawl
      let angle = p.frameCount * -0.015; 
      
      p.rotate(angle);
      p.stroke(BLACK);
      p.strokeWeight(2.5);
      p.strokeCap(p.ROUND);
      p.line(0, 0, 0, -handLength); // Shorter long hand
      
      p.pop();
    };

    p.draw = () => {
      p.background(BEIGE);
      grid(p);
      maincontent();
      statictext();
    };
  };

  return (
    <div style={{ backgroundColor: bgcolor }}>
      <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
        <ReactP5Wrapper sketch={sketch} />
      </div>
    </div>
  );
};

export default Rewindtime;